import Heading from "src/components/Heading/Heading";

const PeSeoContent = () => {
    const tabIndex = -1;
    return (
        <>
            <Heading tag={'h'} level="h2">Premature Ejaculation Treatment</Heading>
            <p>
                In this day and age, a lot of people still have the
                misconception that talking about premature ejaculation is taboo
                and that premature ejaculation treatment should not be openly
                discussed. Well, we&apos;re here to talk about this condition and
                normalise it as a topic - all in the name of better sexual
                health for all men.
            </p>
            <p>
                Contrary to popular belief, premature ejaculation is a common
                medical condition. In fact, statistics have shown that for every
                three men, one of them would struggle with this issue.
                <a tabIndex={tabIndex} href="#references">[1]</a> Men who have this condition don&apos;t
                have to be embarrassed about it because it can be solved through
                proper treatment by doctors.&nbsp;
            </p>
            <Heading level="h3" tag="h">Doctors you can freely talk to</Heading>
            <p>
                You don&apos;t have to go to a physical{' '}
                <a
                    tabIndex={tabIndex}
                    href="/"
                    target="_blank"
                    rel="noopener"
                >
                    men&apos;s health clinic
                </a>{' '}
                because here at Mosh, we have Australia-based doctors who work
                independently. They are our contractors, not employees - which
                means that they can go above and beyond when it comes to your
                premature ejaculation treatment and advice. They are not obliged
                to prescribe you{' '}
                <a
                    tabIndex={tabIndex}
                    href="/premature-ejaculation/medication"
                    target="_blank"
                    rel="noopener"
                >
                    premature ejaculation medication
                </a>{' '}
                or{' '}
                <a
                    tabIndex={tabIndex}
                    href="/premature-ejaculation/pills"
                    target="_blank"
                    rel="noopener"
                >
                    pills to last longer in bed
                </a>{' '}
                if they are not actually necessary for you. Instead, our doctors
                will only recommend a treatment plan if it aligns with your
                sexual health goals.&nbsp;
            </p>
            <p>
                You can ask our doctors anything related to your sexual health.
                Whether you inquire '
                <a
                    tabIndex={tabIndex}
                    href="/blog/how-to-stop-premature-ejaculation"
                    target="_blank"
                    rel="noopener"
                >
                    How to stop premature ejaculation
                </a>
                ?' or '
                <a
                    tabIndex={tabIndex}
                    href="/blog/how-to-last-longer-in-bed"
                    target="_blank"
                    rel="noopener"
                >
                    How to last longer in bed
                </a>
                ', our doctors have the expertise to provide you with
                answers.&nbsp;
            </p>
            <p>
                If you&apos;re looking for treatments to solve some of your other
                medical problems, our online men&apos;s health platform also allows
                you to tackle{' '}
                <a
                    tabIndex={tabIndex}
                    href="/hair-growth/regrowth"
                    target="_blank"
                    rel="noopener"
                >
                    hair regrowth for men
                </a>{' '}
                and even find a licensed{' '}
                <a
                    tabIndex={tabIndex}
                    href="/mental-health"
                    target="_blank"
                    rel="noopener"
                >
                    psychologist online
                </a>
                . With Mosh, you can receive advice from a number of medical
                professionals.&nbsp;
            </p>
            <p>Subscribe to Mosh now and be treated the right way!</p>
            <Heading tag="h" level="h3">What is premature ejaculation?&nbsp;</Heading>
            <p>
                Generally, if you ejaculate less than one minute after
                penetration and it&apos;s causing you distress, then you are
                experiencing premature ejaculation. However, a definition like
                this does not give a clear-cut answer as preferred orgasm time
                varies from relationship to relationship.&nbsp;
            </p>
            <p>
                One man might think he needs a premature ejaculation fix because
                his partner wants him to last significantly longer in bed. On
                the other hand, another man might want to buy premature
                ejaculation pills because he himself is bothered with how fast
                he reaches his climax.&nbsp;
            </p>
            <p>
                Studies on ejaculation time have been conducted. One study found
                that the average male takes about 5.5 minutes to ejaculate
                during sexual intercourse<a tabIndex={tabIndex} href="#references">[2]</a> while
                another study that involved Canadian and American sex therapists
                suggests that 'normal' climax times should be around 3 to 13
                minutes.<a tabIndex={tabIndex} href="#references">[3]</a>
            </p>
            <p>
                Based on the above information, premature ejaculation ultimately
                depends on your and your partner&apos;s point of view. If both of you
                average a shorter time, then there would most likely be little
                to no conflict. However, if your partner is unsatisfied about
                the short amount of time it takes for you to climax, then it may
                be time to consult a doctor.&nbsp;
            </p>
            <p>
                By taking advantage of our services at Mosh, you can skip long
                and embarrassing lines in physical clinics. With us, you can
                consult with a doctor without the fear of people hearing about
                your personal situation. Subscribe to Mosh today and get a
                personalised premature ejaculation treatment that is tailored to
                your specific needs.&nbsp;
            </p>
            <Heading tag="h" level="h3">
                What are the signs and symptoms of premature ejaculation?&nbsp;
            </Heading>
            <p>
                There are not a lot of signs and symptoms of premature
                ejaculation that tell you when to go see a doctor. However, the
                primary symptom of this condition is the inability to control
                how fast you reach climax. More specifically, it is when you do
                not have the ability to restrain yourself from ejaculating for
                more than one minute after sexual intercourse has commenced.
                <a tabIndex={tabIndex} href="#references">[4]</a>
            </p>
            <p>
                Generally, doctors use this simple guide to form a diagnosis and
                see if you can gain from premature ejaculation treatment:
            </p>
            <ol>
                <li>Ejaculating within one minute of penetration</li>
                <li>
                    Having difficulty delaying ejaculation during sex all the
                    time or nearly all the time&nbsp;
                </li>
                <li>
                    Experiencing feelings of frustration, depression, and
                    anxiety as effects of the quick climax
                </li>
            </ol>
            <p>
                If you almost always feel or experience these three symptoms,
                then perhaps it is time to seek a medical professional. Take
                advantage of our quality services at Mosh and be on top of your
                medical condition. Consult with one of our doctors at your
                convenience via call, video chat, or text; and they will provide
                you with personalised treatment for premature ejaculation.&nbsp;
            </p>
            <Heading tag="h" level="h3">How to treat premature ejaculation?</Heading>
            <p>
                There are two types of premature ejaculation treatment - home
                remedies and professional solutions. Listed here are some of the
                home remedy solutions you can try out when you have intimate
                relations with your partner.&nbsp;
            </p>
            <ol>
                <li>
                    <strong>Thicker condoms. </strong>For some men, using a
                    thick condom can delay premature ejaculation. This is
                    because the layer of rubber and latex reduces the sensation
                    your erection feels.&nbsp;
                </li>
                <li>
                    <strong>Longer foreplay. </strong>Sex does not just involve
                    penetration. It can be greatly enhanced by foreplay. The
                    longer the foreplay, the higher the chances you will delay
                    your ejaculation.
                </li>
                <li>
                    <strong>Slower rhythm. </strong>Having a slower rhythm or
                    motion during sex will allow you to better control the
                    amount of pleasure you receive.
                </li>
            </ol>
            <p>
                However, if you are looking for professional solutions such as
                pills to help you last longer or other forms of medicine for
                premature ejaculation, then it is best to consult with a
                doctor.&nbsp;
            </p>
            <p>
                Mosh excels in this area. Our team of medical professionals
                understands that natural and home remedies may not work or be
                suitable for everyone. That is why we are here to provide you
                with the premature ejaculation treatment that is tailored to
                your situation.&nbsp;
            </p>
            <p>
                When you consult with our doctors, they will diagnose and
                provide you with appropriate premature ejaculation treatment if
                appropriate. We will then ship your treatment discreetly. Our
                subscription includes unlimited follow-ups and automatic refills
                as needed, so you have one less thing to worry about.&nbsp;
            </p>
            <p>
                Sign up now as a patient at Mosh to enjoy life&apos;s natural
                pleasure for longer.&nbsp;
            </p>
            <div className="content_references" id="references">
                <Heading level="h3" tag="h">References</Heading>
                <ol>
                    <li>
                        <a  
                            tabIndex={tabIndex}
                            href="https://www.mayoclinic.org/diseases-conditions/premature-ejaculation/symptoms-causes/syc-20354900"
                            target="_blank"
                            rel="noopener"
                        >
                            https://www.mayoclinic.org/diseases-conditions/premature-ejaculation/symptoms-causes/syc-20354900
                        </a>
                    </li>
                    <li>
                        <a  
                            tabIndex={tabIndex}
                            href="https://pubmed.ncbi.nlm.nih.gov/16422843/"
                            target="_blank"
                            rel="noopener"
                        >
                            https://pubmed.ncbi.nlm.nih.gov/16422843/
                        </a>
                    </li>
                    <li>
                        <a  
                            tabIndex={tabIndex}
                            href="https://pubmed.ncbi.nlm.nih.gov/18331255/"
                            target="_blank"
                            rel="noopener"
                        >
                            https://pubmed.ncbi.nlm.nih.gov/18331255/
                        </a>
                    </li>
                    <li>
                        <a  
                            tabIndex={tabIndex}
                            href="https://www.mayoclinic.org/diseases-conditions/premature-ejaculation/symptoms-causes/syc-20354900"
                            target="_blank"
                            rel="noopener"
                        >
                            https://www.mayoclinic.org/diseases-conditions/premature-ejaculation/symptoms-causes/syc-20354900
                        </a>
                    </li>
                </ol>
            </div>
        </>
    );
};

export default PeSeoContent;
